<template>
    <div>
      <v-sheet outlined class="d-flex align-center justify-space-between ma-2 px-4" height="60">
        <font class="font-weight-bold text-h6 grey--text text--darken-2">트래블러 매출 관리</font>
        <v-btn-toggle v-model="selectedYear" mandatory>
          <v-btn value="2025" text>2025년</v-btn>
        </v-btn-toggle>
      </v-sheet>
  
      <LafiaTravelerEachDate v-show="!isDetail" @open="openDetail" :selectedYear="selectedYear"/>
      <LafiaTravelerDetail v-if="isDetail" :month="selectedMonth" :code="selectedTravelerCode" :total="selectedItem" @prev="openList" />
    </div>
  </template>
  <script>
  import LafiaTravelerEachDate from "./components/lafiaTravelerEachDate"
  import LafiaTravelerDetail from "./components/lafiaTravelerDetail"
  
  export default {
    components: {
        LafiaTravelerEachDate,
        LafiaTravelerDetail,
    },
    data: () => ({
      isDetail: false,
      selectedYear: "2025",
      selectedMonth: 1,
      selectedItem: null,
      selectedTravelerCode: null,
    }),
    created() {
      this.selectedMonth = this.dayjs().month()
    },
    methods: {
      openDetail({ item, code }) {
        console.log(`openDetail`, item, code)
        this.selectedMonth = Number(item.date.split("-")[1]) - 1
        this.selectedTravelerCode = code
        this.selectedItem = item
        this.isDetail = true
      },
      openList() {
        this.selectedItem = null
        this.selectedTravelerCode = null
        this.isDetail = false
      },
    },
  }
  </script>
  <style></style>
  